/*
 * @Author: Smart Chow
 * @Date: 2022-01-05 21:32:10
 * @LastEditors: Smart Chow
 * @LastEditTime: 2022-05-06 15:49:57
 * @FilePath: /nqc-ui/src/frameworks/http/request.js
 */
import axios from 'axios'
import { Message } from 'win-design'
import router from '../router/index'
import store from '../store/index'
import eventBus from '@/frameworks/events/eventBus'

// create an axios api instance
const apiService = axios.create({
  baseURL:
    process.env.NODE_ENV !== 'production' ? window.globalConfig.BaseUrl : '/', // api 的 base_url
  timeout: 200000, // request timeout
  withCredentials: !!window.globalConfig.isProductMode // 允许携带cookie
})
let flag = true
// request interceptor
apiService.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    // config.headers['Authorization'] = 'Bearer ' + tokenService.getTokenValue()
    config.headers = {
      'Content-Type': 'application/json'
    }
    return config
  },
  (error) => {
    // Do something with request error
    Promise.reject(error)
  }
)

// response interceptor
apiService.interceptors.response.use(
  async (response) => {
    let dataAxios = response.data
    // 为了特殊处理下载文件失败或者token失效的问题
    if (
      response.request.responseType === 'blob' &&
      dataAxios.type === 'application/json'
    ) {
      await new Promise((resolve, reject) => {
        var reader = new FileReader()

        reader.onload = (e) => {
          const obj = JSON.parse(e.target.result)
          if (obj) {
            dataAxios = obj
          }
          resolve()
        }
        reader.readAsText(dataAxios)
      })
    }
    /**
     * response没有status直接返回
     */
    if (!response.status) {
      return
    }
    /**
     * response.status 不是200时的处理.
     */
    if (response.status !== 200) {
      return Promise.reject('error')
    } else {
      if (response.data && response.data.errorCode) {
        Message({
          message: response.data.errorMsg,
          type: 'error',
          duration: 5 * 1000
        })
        return
      } else {
        if (
          response.data.code == 403 &&
          flag &&
          !router.currentRoute.query.skipPwd
        ) {
          flag = false
          if (store.state.app.isMulHospital) {
            eventBus.$emit('REFRESH_TOKEN_FAILE', '')
            flag = true
            return
          }
          store._vm.$Alert('登录已过期，即将跳转至登录页面').finally((res) => {
            if (store.state.user.RedirectUrl) {
              window.location.href = store.state.user.RedirectUrl
            } else {
              router.push('/')
            }
            store._vm.$dlg.close()
            flag = true
          })
          return
        }
        if (!response.data.success) {
          Message({
            message: response.data.message,
            type: 'error',
            duration: 5 * 1000
          })
        }
        return response.data
      }
    }
  },
  async (error) => {
    if (!error.response || error.message === 'Network Error') {
      const errorData = {
        errorCode: '-99',
        errorMsg: '网络访问异常！',
        errorStack: error.stack
      }
      return Promise.reject(errorData)
    } else if (error.response.status === 500) {
      // return Promise.reject(error.response.data)
      return //不弹报错信息
    } else if (error.response.status === 404) {
      // 404 的错误重新包装下
      const errorData = {
        errorCode: '-1',
        errorMsg: '调用的数据接口不存在，请联系管理员'
      }
      return Promise.reject(errorData)
    } else {
      const errorData = {
        errorCode: '-1',
        errorMsg: error.message,
        errorStack: error.stack
      }
      // return Promise.reject(errorData)
      return //不弹报错信息
    }
  }
)

export { apiService }
